<script>
export default {
  name: 'TemplateHeader',
  props: {
    title: String,
    shadow: {
      type: Boolean,
      default: true,
    },
    titleFull: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'template-header--shadow': this.shadow,
        'template-header--title-full': this.titleFull,
      };
    },
    titleMenu() {
      return this.$core.template.menu.show ? 'MC__HIDE' : 'MC__SHOW';
    },
  },
  watch: {
    title() {
      this.setTitle();
    },
  },
  methods: {
    handlerMenu() {
      this.$core.template.menu.show = !this.$core.template.menu.show;
    },
    setTitle() {
      if (this.title) {
        document.title = this.title;
        window.MagTemplate.title = this.title;
      }
    },
  },
  mounted() {
    this.setTitle();
  },
};
</script>
<template>
  <header class="template-header" :class="classes" v-if="$slots.default||$slots.right">
    <div class="template-header__main">
      <div class="template-header__filter">
        <slot></slot>
      </div>
      <div class="template-header__right">
        <slot name="right"></slot>
      </div>
    </div>
    <slot name="bottom"></slot>
  </header>
</template>
<style lang="scss">
  .template-header {
    background: #ffffff;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    margin-top: 24px;


    &__main {
      display: flex;
      align-items: center;
      height: 66px;
      padding: 0 16px;
    }

    &__title {
      font-size: 22px;
      padding: 0 16px;
      font-weight: 400;
      width: 280px;
      text-transform: uppercase;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: 100%;
      display: flex;
      align-items: center;
    }

    &__filter {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
    }

    &__right {
      flex-shrink: 0;
    }

    &.template-header--shadow {
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
      0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12);
      border: none;
    }

    &--title-full {
      .template-header__title {
        width: 100%;
      }
    }
  }

  @media (max-height: 600px) {
    .template-header {
      &__title {
        line-height: 30px;
        font-size: 18px;
        padding-left: 8px;
      }

      &__main {
        height: 44px;
        padding: 0 4px 0 8px;
      }

      &__menu {
        button {
          height: 34px;
          width: 34px;
          padding: 4px;
          font-size: 18px;
          margin: 0;
        }
      }
    }
  }
</style>
